import createMetadataAPITypes from '../../utils/api-metadata-types';
import moment from 'moment';

const options = {
  name: 'contractWorkloadBreakdown',
  baseType: 'CONTRACT_WORKLOAD_BREAKDOWN',
  apiEndpoint: 'contracts/{id}/workload_breakdown'
};

const types = createMetadataAPITypes(options);

import createMetadataAPIReducer from '../../utils/api-metadata-reducer';

const initialState = {
  byId: {},
  ids: [],
  lastError: null,
  error: null,
  lastFetch: null,
  loading: false
};

// Example structure:
//
// {
//  byId: {
//    432: { // contract id
//      stats: {
//        'quarter_hour': [list of contract workload breakdowns with distinct start times]
//        'month_shift': [list of contract workload breakdowns with distinct start times]
//      }
//    }
// }

const calculateKey = contract => `${contract.period_type}_${contract.time_unit}`;

const defaultReducer = createMetadataAPIReducer({
  baseType: 'CONTRACT_WORKLOAD_BREAKDOWN'
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS: {
      const { data } = action.payload;
      const { id, start_time } = data;

      const key = calculateKey(data);

      // all contract workloads for the contract
      const oldWorkloadBreakdown = (state.byId[data.id] || {}).data || {};
      // all constract workloads for the the same period_type and time_unit
      const oldWorkloadBreakdownForPeriodAndUnit = oldWorkloadBreakdown[key] || [];

      const newWorkloadBreakdownForPeriodAndUnit = [
        ...oldWorkloadBreakdownForPeriodAndUnit.filter(s => s.start_time !== start_time),
        data
      ];

      const newContract = {
        user_id: data.user_id,
        data: {
          ...oldWorkloadBreakdown,
          [key]: newWorkloadBreakdownForPeriodAndUnit
        },
        loaded: true
      };

      const newById = { ...state.byId, [id]: newContract };

      return { ...state, byId: newById, lastFetch: moment().format() };
    }
    default: {
      return defaultReducer(state, action);
    }
  }
};
